import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

import StatusIcon from 'ui/StatusIcon';

const styles = theme => ({
    root: {
        position: 'relative',
    },
    body: {
        position: 'absolute',
        top: theme.spacing(),
        right: theme.spacing(),
        display: 'flex',
    },
    label: {
        marginLeft: theme.spacing(),
    },
    small: {
        fontSize: '1em',
    },
});
function Status({ status, small, classes }) {
    const labelClassName = classNames(classes.label, {
        [classes.small]: small,
    });
    return (
        <div className={classes.root}>
            <div className={classes.body}>
                <StatusIcon
                    active={status}
                    size={small ? 'small' : 'default'}
                />
                <Typography
                    component="div"
                    color="textSecondary"
                    className={labelClassName}
                >
                    {status ? 'Enabled' : 'Disabled'}
                </Typography>
            </div>
        </div>
    );
}

export default withStyles(styles)(Status);
